import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import type { MemberState } from '@/interfaces/store';

const state: MemberState = {};

const mutations = {
    setMemberState(state: MemberState, member: MemberState) {
        Object.assign(state, member);
    },
    resetMemberState(state: MemberState) {
        Object.assign(state, {});
    },
};

const actions = {
    async setMemberInfo(
        {
            commit,
        }: {
            commit: (mutation: string, payload?: object | undefined) => void;
        },
        member: MemberState,
    ) {
        commit('setMemberState', member);
    },
    resetMemberInfo({ commit }: { commit: (mutation: string, payload?: unknown) => void }) {
        commit('resetMemberState');
    },
};

const getters = {
    memberInfo: (state: MemberState) => {
        return state;
    },
};

const memberModule: Module<MemberState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default memberModule;
